import { Route, Routes } from 'react-router-dom';
import { LodgeReturnRoutes } from './routes/LodgeReturn/routes';
import TaxAdvicePage from './routes/TaxAdvice';
import PaymentSuccess from './routes/PaymentSuccess';
import PaymentCancel from './routes/PaymentCancel';
import PreapprovalPage from './routes/PreApproval';
import ContainerWrapper from '../layout/ContainerWrapper';
import SettledPage from './routes/Settled';
import TaxDealStage from './routes/TaxDealStage';
import NotFoundPage from '../mics/routes/NotFound';
import TaxPage from './routes/TaxPage';
import HealthCheck from './routes/HealthCheck';

export const TaxRoutes = () => {
  return (
    <ContainerWrapper>
      <Routes>
        <Route path="/" element={<TaxPage />} />
        <Route path="lodge-return/*" element={<LodgeReturnRoutes />} />
        <Route path="tax-advice/" element={<TaxAdvicePage />} />
        <Route path="pre-approval/" element={<PreapprovalPage />} />
        <Route path="settled/" element={<SettledPage />} />
        <Route path="tax-deal-stage/" element={<TaxDealStage />} />
        <Route path="payment/success" element={<PaymentSuccess />} />
        <Route path="payment/cancel" element={<PaymentCancel />} />
        <Route path="health-check" element={<HealthCheck />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ContainerWrapper>
  );
};
